import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PurchaseStateContextProvider } from "@/app/lib/context/PurchaseStateContext";
import { useHotelSearch } from "@/app/lib/hooks/useHotelSearch";
import { SearchDataMissingErrorBoundary } from "@/app/lib/errors/SearchDataMissingErrorBoundary";

export const Route = createFileRoute("/_authenticated/_hotels")({
  component: HotelsRoute,
});

function HotelsRoute() {
  return (
    <SearchDataMissingErrorBoundary>
      <RouteComponent />
    </SearchDataMissingErrorBoundary>
  );
}

function RouteComponent() {
  // this is only to initiate cache
  useHotelSearch();

  return (
    // FlightSelectionPayloadProvider is here only because it's needed
    // in PaymentContextProvider which is used for both flight and hotel
    // but it will be empty as user don't have UI to modify it
    // during hotel booking flow
    <PurchaseStateContextProvider>
      <Outlet />
    </PurchaseStateContextProvider>
  );
}
